import * as _ from "lodash";
var ConfigurationService = /** @class */ (function () {
    function ConfigurationService() {
        this.enforceSuffix = "-enforce";
        this.configuration = [];
    }
    ConfigurationService.prototype.add = function () {
        var configurationItems = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            configurationItems[_i] = arguments[_i];
        }
        for (var i = 0; i < configurationItems.length; i++) {
            var baseConfigurationItem = {
                key: undefined,
                type: undefined,
                scope: undefined,
                value: undefined
            };
            configurationItems[i] = _.merge(baseConfigurationItem, configurationItems[i]);
            this.remove(configurationItems[i].key, configurationItems[i].scope);
        }
        this.configuration = this.configuration.concat(configurationItems);
    };
    ConfigurationService.prototype.remove = function (key, scope) {
        if (_ && _.remove) {
            _.remove(this.configuration, { key: key, scope: scope });
        }
    };
    ConfigurationService.prototype.update = function () {
        var configurationItems = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            configurationItems[_i] = arguments[_i];
        }
        this.add.apply(this, configurationItems);
    };
    ConfigurationService.prototype.getList = function (type, scope) {
        var result = {};
        var siteLevelHeaders = this.excludeSiteConfiguration(scope) ?
            [] :
            _.filter(this.configuration, {
                type: type,
                scope: undefined
            });
        var scopeLevelHeaders = _.filter(this.configuration, {
            type: type,
            scope: this.getScopeName(scope)
        });
        _.forEach(siteLevelHeaders, function (element) {
            result[element.key] = element.value;
        });
        _.forEach(scopeLevelHeaders, function (element) {
            result[element.key] = element.value;
        });
        return result;
    };
    ConfigurationService.prototype.getByKey = function (key, scope) {
        if (this.excludeSiteConfiguration(scope)) {
            var result = _.find(this.configuration, {
                key: key,
                scope: this.getScopeName(scope)
            });
            return (result ? result.value : null);
        }
        else {
            var result = _.find(this.configuration, {
                key: key,
                scope: scope
            });
            if (!_.isUndefined(scope) && !result) {
                result = _.find(this.configuration, {
                    key: key,
                    scope: undefined
                });
            }
            return (result ? result.value : null);
        }
    };
    ConfigurationService.prototype.getByKeyOrDefault = function (key, defaultValue, scope) {
        var result = this.getByKey(key, scope);
        return result == null ? defaultValue : result;
    };
    ConfigurationService.prototype.excludeSiteConfiguration = function (scope) {
        if (scope && _.endsWith(scope, this.enforceSuffix)) {
            // exclude scope-less configuration, this is a "clean" configuration set
            return true;
        }
        return false;
    };
    ConfigurationService.prototype.getScopeName = function (scope) {
        if (this.excludeSiteConfiguration(scope)) {
            return scope.substr(0, scope.lastIndexOf(this.enforceSuffix));
        }
        return scope;
    };
    return ConfigurationService;
}());
export { ConfigurationService };
